
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';
import NoResultsFound from '@/features/common/components/NoResultsFound.vue';
import { fetchMoreUsingScrollWindow } from '@/features/common/helpers';
import { SelectedUnscheduledPickup, UnscheduledPickups } from '@/features/schedule-pickup/types';
import PickupItem from './PickupItem.vue';

@Component({
  components: {
    DataTableWrapper,
    PickupItem,
    NoResultsFound,
  },
})
export default class PendingTable extends Vue {
  @Prop({ required: true }) unscheduledPickups!: UnscheduledPickups[];

  @Prop({ required: true }) dateSortingActive!: boolean;

  @Prop({ required: true }) order!: boolean;

  @Prop({ required: false, default: false }) loading!: boolean;

  @Prop({ required: true }) isSelectAll!: boolean;

  @Prop({ required: true }) selectedPickups!: SelectedUnscheduledPickup[];

  @Prop({ required: false, default: true }) isLoadMoreHint!: boolean;

  private isPickupSelected(index: number): boolean {
    const pickupItem = this.selectedPickups.find((pickup) => pickup.index === index);
    return !!pickupItem;
  }

  mounted(): void {
    const onScroll = () => {
      this.debounceFetchUnScheduledPickup();
    };

    window.addEventListener('scroll', onScroll);
  }

  private debounceFetchUnScheduledPickup = debounce(this.fetchMoreUnschedulePickupHandler, 200);

  private async fetchMoreUnschedulePickupHandler(): Promise<void> {
    const callback = () => {
      this.$emit('fetchMorePickups');
    };

    fetchMoreUsingScrollWindow(callback);
  }
}
